import { createEvent, createStore } from "effector";

const defaultPreferedRowsPerPage = 10;

export const preferedRowsPerPage = createStore(defaultPreferedRowsPerPage);

export const preferedRowsPerPageChanged = createEvent<number | undefined>(
  "rowsPerPageChanged"
);

preferedRowsPerPage.on(
  preferedRowsPerPageChanged,
  (_state, value) => value || defaultPreferedRowsPerPage
);
